import { Badge, Button, Modal } from "react-bootstrap";
import QuickForm from "../../Forms/QuickForm/QuickForm";
import timeService from "../../../services/time/timeService";
import { useState } from "react";
import { useAppDispatch } from "../../../redux/store";
import { showError } from "../../../redux/counter/counterSlice";
import { useBulkEditBookingsMutation, useEditBookingMutation } from "../../../services/bClientApi";
import useMyProperties from "../../../Hooks/UseMyProperties/UseMyPropertiesHook";
import useRelatedBookings from "../../../Hooks/UseRelatedBookings/UseRelatedBookings";
import { Link } from "react-router-dom";
import { PropertyBookingEntry } from "../../../Types/bookingTypes";
import { isParent } from "../../../Helpers/Property/isParent";

export default function BookingModal(props: {
    active: boolean,
    booking: any
    clearBookingModal: () => void,
    bookingModalonSubmit: (values: any, relatedBookings: any[]) => void,
}) {
    const {
        active,
        booking,
        clearBookingModal,
        bookingModalonSubmit,
    } = props

    let bookingId = ''
    if (booking && booking._id) {
        bookingId = booking._id
    }

    const { myProperties } = useMyProperties()

    const relatedBookings = useRelatedBookings(bookingId, booking, myProperties)

    return (
        <Modal show={active} onHide={clearBookingModal}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Booking</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                {booking && (
                    <>
                        <b>Booking ID:</b> {booking._id} <br />
                        <b>Name: </b> {booking.contactInfo.firstName} {booking.contactInfo.lastName} <br />
                        {/* <b>Check In: </b> {timeService.getFormattedTime(editBookingModal.booking.checkIn)} <br /> */}
                        {/* <b>Check Out: </b> {timeService.getFormattedTime(editBookingModal.booking.checkOut)} <br /> */}

                        {relatedBookings && relatedBookings.length > 0 && (
                            <div className="related-bookings mt-2 mb-4">
                                <b>Related Bookings</b>
                                <div>
                                    {relatedBookings.map((b: PropertyBookingEntry) => {
                                        const propertyInfo = myProperties[b.propertyId]
                                        const duplicateRelated = b.propertyId === booking.propertyId
                                        return (
                                            <div key={b._id}>
                                                <Link to={`/booking/${b._id}`}>
                                                    {propertyInfo.title}
                                                </Link>  {isParent(myProperties[b.propertyId], myProperties[booking.propertyId]) && (
                                                    <span className="parent-property"> - Parent (edit this to keep changes synced)&nbsp;</span>
                                                )}

                                                {duplicateRelated && (
                                                    <Badge bg="danger">DUPLICATE</Badge>
                                                )}
                                                {/* <div
                                                    role="button"
                                                    className="d-inline-block"
                                                    onClick={() => {
                                                        setBookingPreview({ booking })
                                                    }}
                                                >
                                                    👀
                                                </div> */}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )}

                        <QuickForm
                            key={`${booking._id}}`}
                            initialData={{
                                checkIn: new Date(booking.checkIn),
                                checkOut: new Date(booking.checkOut),
                            }}
                            fields={[
                                {
                                    fieldName: 'checkIn',
                                    fieldLabel: 'Check In',
                                    fieldType: 'date',
                                    required: true,
                                    layout: {
                                        xs: 12,
                                        md: 6,
                                    },
                                },
                                {
                                    fieldName: 'checkIn',
                                    fieldLabel: 'Check In Time',
                                    fieldType: 'date',
                                    required: true,
                                    extra: {
                                        showTimeSelect: true,
                                        showTimeSelectOnly: true,
                                        // timeIntervals: 15,
                                        dateFormat: "h:mm aa",
                                        showTimeCaption: false
                                    },
                                    layout: {
                                        xs: 12,
                                        md: 6,
                                    },
                                },
                                {
                                    fieldName: 'checkOut',
                                    fieldLabel: 'Check Out',
                                    fieldType: 'date',
                                    required: true,
                                    layout: {
                                        xs: 12,
                                        md: 6,
                                    },
                                },
                                {
                                    fieldName: 'checkOut',
                                    fieldLabel: 'Check Out Time',
                                    fieldType: 'date',
                                    required: true,
                                    extra: {
                                        showTimeSelect: true,
                                        showTimeSelectOnly: true,
                                        // timeIntervals: 15,
                                        dateFormat: "h:mm aa",
                                        showTimeCaption: false
                                    },
                                    layout: {
                                        xs: 12,
                                        md: 6,
                                    },
                                },
                            ]}
                            onSubmit={(values: any) => {
                                console.log('BookingModal onSubmit', values)
                                bookingModalonSubmit(values, relatedBookings)
                            }}
                        />
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={clearBookingModal}>
                    Close
                </Button>
                {/* <Button variant="primary" onClick={clearBookingModal}>
                Save Changes
            </Button> */}
            </Modal.Footer>
        </Modal>
    )
}

export function useBookingModal() {
    const [editBookingModal, setEditBookingModal] = useState<any>({
        active: false,
        booking: null,
    })

    const { myProperties } = useMyProperties()

    const [
        editBooking,
    ] = useEditBookingMutation()

    const [
        bulkEditBookings,
        // {
        //   error: bulkEditError,
        //   isLoading: bulkEditLoading,
        // }
    ] = useBulkEditBookingsMutation()

    const dispatch = useAppDispatch()

    const clearBookingModal = () => {
        setEditBookingModal({
            active: false,
            booking: null,
        })
    }

    const openBookingModal = (b: any) => {
        setEditBookingModal({
            active: true,
            booking: { ...b },
        })
    }

    const onEditClick = (b: any) => {
        openBookingModal(b)
    }

    const onCheckOutClick = (b: any) => {
        const updatedB: any = {
            ...b
        }
        updatedB.checkOut = timeService.getCurrentTime().startOf('hour').toJSDate()
        openBookingModal(updatedB)
    }

    // const bookingModalonSubmit = async (b: any) => {
    //     const editedBooking = await editBooking({
    //         bookingId: editBookingModal.booking._id,
    //         bookingInfo: {
    //             checkIn: b.checkIn,
    //             checkOut: b.checkOut,
    //         }
    //     }).unwrap()
    //     if (editedBooking && editedBooking._id) {
    //         clearBookingModal()
    //     } else {
    //         dispatch(showError('Error updating booking'))
    //     }
    // }

    const bookingModalonSubmit = async (data: any, relatedBookings: any[]) => {
        const values: any = {
            _id: editBookingModal.booking ? editBookingModal.booking._id : null,
            ...data
        }

        // if (_id) {
        if (editBookingModal.booking && editBookingModal.booking._id) {
            // check for related bookings
            if (relatedBookings && relatedBookings.length > 0) {
                // if there are related bookings, check if any are child bookings
                const childBookings = relatedBookings.filter(b => !isParent(myProperties[b.propertyId], myProperties[editBookingModal.booking.propertyId]))
                if (childBookings.length > 0) {
                    const bookingsToEdit = [{ ...values }]
                    childBookings.forEach(booking => {
                        const editedChildBooking = {
                            ...values,
                            _id: booking._id,
                            propertyId: booking.propertyId,
                            // pricePerNight: values.pricePerNight ? values.pricePerNight / childBookings.length : 0,
                            requiresConfirmation: booking.requiresConfirmation,
                            requiresBookingGuestInfo: booking.requiresBookingGuestInfo ? booking.requiresBookingGuestInfo : false,
                            confirmationCode: booking.confirmationCode,
                            linkedServices: booking.linkedServices ? [...booking.linkedServices] : [],
                            turnoverId: booking.turnoverId ? booking.turnoverId : ''

                        }

                        if (values.pricePerNight && childBookings.length > 0 && values.pricePerNight > 0) {
                            // divide the pricePerNight among the child bookings
                            editedChildBooking.pricePerNight = values.pricePerNight / childBookings.length
                            editedChildBooking.earnings = values.earnings ? values.earnings / childBookings.length : 0
                        }

                        bookingsToEdit.push(editedChildBooking)
                    })
                    const newBookings = await bulkEditBookings(bookingsToEdit).unwrap()
                    if (newBookings && !newBookings.error) {
                        // dispatch(navigateTo(`/bookings?query={"firstName":"${values.contactInfo?.firstName}","lastName":"${values.contactInfo?.lastName}"}`))
                        clearBookingModal()
                    } else {
                        dispatch(showError('Error updating related bookings'))
                    }
                    return newBookings
                }
            }

            const editedBooking = await editBooking({
                bookingId: editBookingModal.booking._id,
                bookingInfo: values
            }).unwrap()
            if (editedBooking._id) {
                // dispatch(navigateTo(`/booking/${editedBooking._id}`))
                clearBookingModal()
            } else {
                dispatch(showError('Error updating booking'))
            }
            return editedBooking
        }
    }

    return {
        editBookingModal,
        clearBookingModal,
        onEditClick,
        onCheckOutClick,
        bookingModalonSubmit
    }
}